// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1pCRu","content":"styles_content__oooT9","statusBadge":"styles_statusBadge__kpqDZ"};